export const misirWat = {
  id: "misirWat",
  link: "/#/recipes/recipes/misirWat",
  name: "Misir Wat",
  cuisine: "Shin",
  summary: "Spiced stewed lentils. A Shin spin on an Ethiopian classic.",
  inspiration: "Misir Wat",
  quantity: "4 servings",
  time: "1 hour 40 minutes",
  notes:
    "I have to admit that when I read the words \"misir wat\" in Wind and Truth I didn't recognize that it was a real Ethiopian dish. When I did realize what it was, it changed the way I think about Shin food. What I have here is not the same as real Ethiopian misir wat. I've had to change the recipe to match what the book describes, as the process is described in detail, and not all of the ingredients in a traditional misir wat are available on Roshar. Nevertheless, I think I ended up with a delicious dish.",
  quotes:
    "He left his sister and found his mother beside some improvised firepits, discussing an evening meal to hopefully calm everyone down. Misir wat, a thick paste made of red lentils. (Wind and Truth ch 36)",
  image: "https://jozomby-public.s3.amazonaws.com/recipes/misir-wat-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "onion",
          display: "1/2 heaping cup pearl onions"
        },
        {
          item: "oliveOil",
          display: "1/2 cup plus 1 tbsp olive oil"
        },
        {
          item: "garlicClove",
          display: "6 cloves garlic"
        },
        {
          item: "cardamom",
          display: "2 black cardamom pods"
        },
        {
          item: "cinnamon",
          display: "1 small stick cinnamon"
        },
        {
          item: "cloves",
          display: "4 cloves"
        },
        {
          item: "vegetableStock",
          display: "3 cups vegetable stock"
        },
        {
          item: "lentils",
          display: "1 cup red lentils"
        },
        {
          item: "coriander",
          display: "1/2 tsp ground coriander"
        },
        {
          item: "hotPeppers",
          display: "1/2 tsp cayenne powder"
        },
        {
          item: "salt",
          display: "1/2 tsp salt"
        },
        {
          item: "water",
          display: "1/2 cup water"
        }
      ]
    }
  ],
  steps: [
    "If using frozen pearl onions, defrost them and drain off the liquid. If fresh, peel them. Either way, heat 1 tbsp olive oil in a pot over medium high heat, then add the onions and cook and stir until they are browned.",
    "Peel the garlic then add the cloves whole to the pot. Add the cardamom pods, the cinnamon stick and the cloves to the pot. Continue to cook and stir an additional 2 minutes.",
    "Add the vegetable stock to the pot. Cover and reduce heat to simmer. Simmer for 30 minutes.",
    "Remove from heat. Remove the cardamom, cloves and cinnamon from the pot. Discard them, reserve everything else in the pot. Remove the onion and garlic from the pot and mash well with a mortar and pestle. Return mash to pot along with lentils, 1/2 cup olive oil, coriander, cayenne, salt, and water.",
    "Simmer, covered, over low heat, stirring occasionally, for 40 minutes until it forms a medium thick paste. Serve with soda biscuits or bread."
  ]
}
